import {appLink} from "@rw/cars_routes";

const PL_TO_ASCII: Record<string, string> = {
    ą: "a",
    ć: "c",
    ę: "e",
    ł: "l",
    ń: "n",
    ó: "o",
    ś: "s",
    ź: "z",
    ż: "z"
};

/** ASCII slug from seller display name (e.g. "Auto Top" → "auto-top"). */
export const getSellerSlug = (name: string): string =>
    name
        .trim()
        .toLowerCase()
        .split("")
        .map((ch) => PL_TO_ASCII[ch] || ch)
        .join("")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

export const getSellerUrl = (name: string): string | null => {
    const slug = getSellerSlug(name);
    if (!slug) {
        return null;
    }
    return appLink.seller.detail({slug});
};
